
export default function modifyStatus(weather, status) {
    if(weather === 'Clear') {
        return status = 'sunny';
      }else if (weather === 'Rain'){
        return status = 'rainy';
      }else if (weather === 'Snow') {
        return status = 'snowy';
      }else if (weather === 'Drizzle') {
        return status = 'drizzly';
      }else if (weather === 'Clouds') {
        return status = 'cloudy';
      }else {
          return status = '';
      }
}